import { getGameListByJumpList } from "@/lobby_common/api/basic_gen.js";
import { latestList } from "@/lobby_common/api/game_gen.js";
// import { isMobile } from "@/lobby_common/utils/utils.js";
import hideGmae from "@/lobby_common/mixins/hideGmae.js";
import GameMaintai from "@/components/game/game-maintai";
import gameItem from "@/components/game/game-item";
import Collection from "@/components/collection/index.vue";
import { gameImg } from "@/lobby_common/utils/img.js";
import { payGameFun } from "@/lobby_common/utils/payGameFun.js";
import { divideAccuracy, isHome } from "@/lobby_common/utils/utils.js";
import { formattedValue } from "@/lobby_common/utils/index.js";
import {
  getLocalStorage,
  removeLocalStorage,
  setLocalStorage,
} from "@/lobby_common/utils/auth";
import { goJoinEvent } from "@/lobby_common/utils/utils.js";

export default {
  name: "mode4",
  mixins: [hideGmae],
  components: { Collection, GameMaintai, gameItem },
  props: {
    item: {
      type: [Object],
      default: () => ({}),
    },
    curindex: {
      type: Number,
      default: 0,
    },
    skeletonLoading: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formattedValue,
      gameImg,
      cur_left: 0,
      max_left: 0,
      num: 6, // 左右切换每页个数
      timer: null,
      content_index: undefined,
      pcList: [],
      currGameId: undefined,
      target: undefined,
      showType: 1,
      rowNum: 0,
      colNum: 0,
      pageSize: 24,
      page: 1,
      isMore: false, // 是否显示加载更多
      intervalId: null,
      updateInterval: 5000,
      isLatest: false, // 是否是历史游戏
    };
  },
  computed: {
    getImgHeight() {
      const containerWidth =
        document.body.clientWidth > 1340
          ? 1280
          : document.body.clientWidth - 60;
      return containerWidth * 0.15;
    },
    IsMobile() {
      return this.$store.getters.getIsMobile;
    },
    list() {
      // return [...this.pcList];
      return this.pcList.map((item, i) => {
        return {
          ...item,
          currentValue: this.formattedValue(item.currentValue),
          eid: this.isLatest
            ? `101_21_${this.curindex}_${i}`
            : `101_14_${this.curindex}_${i}`,
        };
      });
    },
    lang() {
      return this.$store.getters.getLang;
    },
    coin_accuracy() {
      return this.$store.getters.getPacketConfig?.appConfig?.accuracy
        ? this.$store.getters.getPacketConfig?.appConfig?.accuracy
        : 2;
    },
    accuracy() {
      return this.$store.getters.getCurCoin?.accuracy || this.coin_accuracy;
    },
    packetConfig() {
      return this.$store.getters.getPacketConfig?.packetInfo?.baseInfo || {};
    },
    gameShow() {
      return this.packetConfig.gameNameShowPosition !== 4;
    },
    jp_show() {
      return this.packetConfig.gameIconShowJp === "ROW_STATUS_ENABLE";
    },
    gameThumbWidth() {
      return (
        (100 - 2 * (this.colNum - 1) - (this.showType === 1 ? 2 : 0)) /
        this.colNum
      );
    },
    isLogin() {
      return this.$store.getters.login;
    },
    // storageKey() {
    //   return `${this.isLogin ? 'login' : 'unlogin'}_${this.item.list[0]?.jump?.multipleGame?.sid}_game_list`;
    // },
    storageKey() {
      return `${this.isLogin ? "login" : "unlogin"}_game_list`;
    },
    storageJumpId() {
      return this.item.list[0]?.jump?.multipleGame?.sid;
    },
    titleAlignment() {
      return this.$store.getters.getPacketConfig?.packetInfo?.config
        ?.titleAlignment;
    },
  },
  watch: {},
  async created() {
    console.log(this.item, "mode4 created");
    const arr = this.item.list[0] || {};
    this.isLatest = this.item.tempType === "HOMEPAGE_TYPE_GAME_LATEST";
    this.showType = arr.showType || 1; // 展示模式
    this.rowNum = arr.rowNum || 0; // 行
    this.colNum = arr.colNum || 0; // 列
    this.pageSize =
      this.showType === 1 ? 4 * this.colNum : this.rowNum * this.colNum; // 每页个数
    this.num = this.colNum;

    this.content_index = this.curindex;
    if (this.item.list[0]?.jump?.multipleGame?.sid) {
      // 读取缓存数据
      const storageList = getLocalStorage(this.storageKey);
      if (
        storageList &&
        this.storageJumpId &&
        storageList[this.storageJumpId] &&
        Array.isArray(storageList[this.storageJumpId])
      ) {
        this.pcList = storageList[this.storageJumpId];
      } else {
        // 清空缓存
        removeLocalStorage(this.storageKey);
      }
    }
    await this.getGamelistFunMenu();
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  },
  methods: {
    async getGamelistFunMenu() {
      let code, data;
      if (this.isLatest) {
        // 历史游戏
        const res =
          (await latestList({
            page: 1,
            pageSize: this.pageSize,
            templateType: "history",
          })) || {};
        code = res.code;
        data = res.data || {};
        data.gameList = data.list;
      } else {
        // 游戏展示
        const res =
          (await getGameListByJumpList({
            page: 1,
            pageSize: this.pageSize,
            jumpSid: this.item.list[0].jump.multipleGame?.sid,
            templateType: "home",
          })) || {};
        code = res.code;
        data = res.data;
      }
      if (code === 0) {
        this.isMore =
          data?.gameList &&
          data?.gameList.length > 0 &&
          data?.gameList.length === this.pageSize;
        // this.jp_show = data.jp_show;
        const games = data?.gameList || [];
        games.forEach((item) => {
          if (item.jpInfo && item.jpInfo.jpValue > 0) {
            item.jpInfo.jpValue = divideAccuracy(
              item.jpInfo.jpValue,
              this.accuracy
            );
            item.jpInfo.updateTime = Number(item.jpInfo.updateTime);
          } else {
            item.jpInfo = {
              jpValue: 0,
              updateTime: 0,
            };
          }
          // if (!item.jpInfo.jpValue) {
          //   item.jpInfo = {
          //     jpValue: 7355645,
          //     updateTime: 1715753477788,
          //   };
          // }
          if (data?.isRecommend) {
            // 开启了千人千面
            item.isRecommend = true;
          }
          item.finalValue = item.jpInfo.jpValue;
          item.initiaValue = item.finalValue * 0.8;
          item.currentValue = this.offsetTimeValue(item);
        });
        this.pcList = games;
        // 缓存数据
        if (isHome()) {
          const storeData = getLocalStorage(this.storageKey) || {};
          storeData[this.storageJumpId] = games;
          setLocalStorage(this.storageKey, storeData);
        }
        // this.pcList = data?.gameList || [];
        if (this.jp_show && this.gameShow) {
          this.startIncrement();
        }

        if (this.pcList.length % this.num > 0) {
          // 不能整除
          this.max_left = Math.floor(this.pcList.length / this.num) * 100;
        } else {
          // 能整除
          this.max_left = (Math.floor(this.pcList.length / this.num) - 1) * 100;
        }
      }
    },
    async getGamelistFunMore(page = 1) {
      this.page = page;
      let code, data;
      if (this.isLatest) {
        // 历史游戏
        const res =
          (await latestList({
            page: page || 1,
            pageSize: this.pageSize,
            templateType: "history",
          })) || {};
        code = res.code;
        data = res.data || {};
        data.gameList = data.list;
      } else {
        // 游戏展示
        const res =
          (await getGameListByJumpList({
            page: page || 1,
            pageSize: this.pageSize,
            jumpSid: this.item.list[0].jump.multipleGame?.sid,
            templateType: "home",
          })) || {};
        code = res.code;
        data = res.data;
      }
      // const { code, data } = await getGameListByJumpList({
      //   page: page || 1,
      //   pageSize: this.pageSize,
      //   jumpSid: this.item.list[0].jump.multipleGame.sid,
      //   templateType: "home",
      // });
      if (code === 0) {
        this.isMore =
          data?.gameList &&
          data?.gameList.length > 0 &&
          data?.gameList.length === this.pageSize;
        const games = data?.gameList || [];
        games.forEach((item) => {
          if (item.jpInfo && item.jpInfo.jpValue > 0) {
            item.jpInfo.jpValue = divideAccuracy(
              item.jpInfo.jpValue,
              this.accuracy
            );
            item.jpInfo.updateTime = Number(item.jpInfo.updateTime);
          } else {
            item.jpInfo = {
              jpValue: 0,
              updateTime: 0,
            };
          }
          if (data?.isRecommend) {
            // 开启了千人千面
            item.isRecommend = true;
          }
          item.finalValue = item.jpInfo.jpValue;
          item.initiaValue = item.finalValue * 0.8;
          item.currentValue = this.offsetTimeValue(item);
        });
        this.pcList = [...new Set([...this.pcList, ...games])];
        // this.pcList = [...new Set([...this.pcList, ...(data?.gameList || [])])];
        if (this.jp_show && this.gameShow) {
          this.startIncrement();
        }
      }
    },
    moreFun() {
      this.getGamelistFunMore(this.page + 1);
    },
    startIncrement() {
      if (this.intervalId) {
        clearInterval(this.intervalId);
      }
      this.intervalId = setInterval(() => {
        this.pcList = this.pcList.map((item) => {
          // const minIncrement = item.finalValue * 0.01;
          const maxIncrement = item.finalValue * 0.0005;

          if (item.currentValue < item.finalValue * 0.95) {
            // const randomIncrement = Math.random() * (maxIncrement - minIncrement) + minIncrement;

            item.currentValue += maxIncrement;

            if (item.currentValue > item.finalValue * 0.95) {
              item.currentValue = item.finalValue;
            }
          } else {
            item.currentValue = item.initiaValue;
          }
          return item;
        });
      }, this.updateInterval);
    },
    // 计算差值
    offsetTimeValue(item) {
      const jpInfo = item.jpInfo;
      if (!jpInfo.jpValue || jpInfo.jpValue < 1 || jpInfo.updateTime < 1) {
        return jpInfo.jpValue;
      }
      // 计算时间差值 (当前时间-数据更新时间) / 1000 * 每秒更新值
      const offset =
        ((Date.now() - jpInfo.updateTime) / 5000) * (jpInfo.jpValue * 0.0005);
      let currentValue = jpInfo.jpValue * 0.8 + offset;

      if (currentValue > jpInfo.jpValue * 0.95) {
        currentValue = jpInfo.jpValue * 0.8;
      }

      return currentValue;
    },
    changePosition(dir = "left") {
      const that = this;
      const dom = document.querySelector(`.content_${this.curindex}`);
      if (dom) {
        const target =
          dir === "left" ? that.cur_left - 100 : that.cur_left + 100;
        // if(that.cur_left === 0) dom.style.left = 0
        // else dom.style.left = `-${that.cur_left}00%`
        this.target = target;
        this.animateDom(target, dom, dir);
      }
    },
    animateDom(target, dom, dir) {
      const that = this;
      if (that.timer) {
        return false;
      }
      // let timer = that.timer;
      that.timer = setInterval(function () {
        const speed = dir === "left" ? -5 : 5; // 判断是向左走（负）还是向右走（正）
        // console.log(dir, that.cur_left, target)
        if (that.cur_left === target) {
          clearInterval(that.timer);
          that.timer = null;
        } else {
          that.cur_left = that.cur_left + speed;
          if (that.cur_left === 0) dom.style.left = 0;
          else dom.style.left = `-${that.cur_left}%`;
        }
      }, 10);
    },
    judgeMode(opt) {
      console.log("judgeMode", opt);
      if (this.maintaiGame[opt.gameGroupSid]) {
        return false;
      }
      if (opt.canTestPlay === "STATUS_BOOL_FALSE") {
        this.$store.commit("setRecordGame", opt);

        payGameFun(opt);
      } else {
        if (this.IsMobile) {
          // 游戏详情页面
          this.$isPopShow({
            show: true,
            views: "hgame",
            data: {
              ...opt,
            },
          });
        }
      }
    },
    // PC弹出真玩、试玩收藏
    pcPayGame(opt) {
      if (this.maintaiGame[opt.gameGroupSid]) {
        return false;
      }
      if (this.cur_gid === opt.gameGroupSid) {
        return false;
      }
      if (this.IsMobile) return;
      this.currGameId = opt.gameGroupSid;
      return;
    },
    pcLeaveGame() {
      this.currGameId = null;
      return;
    },
    payGame(opt, canTestPlay, isRoom = false) {
      this.$store.commit("setRecordGame", opt);
      const replace = false;
      payGameFun(opt, canTestPlay, replace, isRoom);
    },
    getGameIcon(keys) {
      const key = keys || null;
      if (key) return require(`@/assets/new/${key}.png`);
    },
    handleClick(item) {
      this.$eventPost("click", {
        eid: `101_0_${this.curindex}_132`,
        time: Date.now(),
      });
      if (this.isLatest) {
        // 历史游戏
        this.$router.push({ name: "history" });
      } else {
        // 游戏展示
        const multipleGame = this.item?.labels[0]?.jump?.multipleGame || null;
        if (
          multipleGame &&
          multipleGame?.secondaryJump1 &&
          multipleGame?.secondaryJump1 !== "-1"
        ) {
          // 设置了 二级界面跳转位置
          goJoinEvent({
            ...this.item?.labels[0]?.jump,
            title: this.item?.labels[0]?.langInfoObj[this.lang]?.title,
          });
        } else {
          item["bindType"] = 2;
          localStorage.setItem("Cur_params", JSON.stringify(item));
          this.$router.push({ name: "homeSearch" });
        }
      }
    },
  },
  activated() {
    if (this.isLatest) {
      this.getGamelistFunMenu();
    }
  },
};
